import {Injectable} from '@angular/core';

export interface MenuDataItem {name:string, href:string, access: keyof AccessToGuides, icon: string}


@Injectable({
  providedIn: 'root'
})
export class MenuDataService {
  public readonly list: readonly MenuDataItem[]= [
    { name: 'Учреждения МКС', href: 'organization', access: 'ref_organization' , icon: 'assets/svg/add_home.svg'},
    { name: 'Объекты учреждений МКС', href: 'facility',  access: 'facility'  ,icon: 'assets/svg/holiday_village.svg'},
    { name: 'Группы учреждений МКС', href: 'group',  access: 'org_group' ,icon: 'assets/svg/domain.svg'},
    { name: 'Структурные подразделения МКС', href: 'department',  access: 'department'  ,icon: 'assets/svg/description.svg'},
    { name: 'Критерии', href: 'criterion',  access: 'criterion' ,icon: 'assets/svg/view_day.svg'},
    { name: 'Целевые ориентиры', href: 'landmarks',  access: 'landmark' ,icon: 'assets/svg/subgroup.svg'},
    { name: 'Показатели', href: 'indicators',  access: 'indicator'  ,icon: 'assets/svg/kind.svg'},
    { name: 'Индексы', href: 'index-entity', access: 'indexentity' , icon: 'assets/svg/blur_on.svg'},
    { name: 'Значения ИАС Спорт', href: 'index-ias',  access: 'indexiasvalue' ,icon: 'assets/svg/remarktype.svg'},
    { name: 'Значения выбора из списка', href: 'index-list-value', access: 'indexlistvalue', icon: 'assets/svg/index-list-value.svg' },
  ] as const;
  public readonly reports: readonly MenuDataItem[]= [
    { name: 'Общий отчет', href: 'report-general', access: 'analytics',icon: 'assets/svg/bar_chart.svg'},
    { name: 'Имущественный комплекс', href: 'report-property', access: 'analytics',icon: 'assets/svg/award_star.svg'},
    { name: 'Динамика занятых мест', href: 'report-occupied-places', access: 'analytics',icon: 'assets/svg/rating.svg'},
    { name: 'Отчет по учреждению', href: 'report-org', access: 'analytics',icon: 'assets/svg/download.svg'},
  ] as const;
  public readonly admin: readonly MenuDataItem[]= [
    { name: 'Администрирование', href: 'users', access: 'useraccount',icon: 'assets/svg/shield_person.svg'},
  ]
}

export type PasFilterType = 'organization' | 'facility' | 'group'
  | 'department' | 'criterion' | 'landmarks' | 'indicators' | 'index-entity'
  | 'index-ias' | 'users' | 'report-general' | 'report-property' | 'report-org'|'report-occupied-places'| 'index-list-value';
